import { render, staticRenderFns } from "./SupplierEidList.vue?vue&type=template&id=1b8a57e8&scoped=true"
import script from "./SupplierEidList.vue?vue&type=script&lang=js"
export * from "./SupplierEidList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a57e8",
  null
  
)

export default component.exports